import { faEnvelope, faLock } from "@fortawesome/pro-light-svg-icons"
import {
  CalloutBox,
  FlexBox,
  JoonUIColor,
  Shadow,
  TextInput,
  Button,
  SPACING,
  Typography,
  createErrorFromResponse,
} from "@joonapp/web-shared"
import { useState } from "react"
import { useNavigate } from "react-router-dom"

import PageWrapper from "../../components/pageWrapper/PageWrapper"
import { createAuth } from "../../networking/authentication/api"
import { FormAlert } from "../../types"
import { createJoonAPIClient } from "../../util/joon-api"
import { sessionManager } from "../../util/storage"

// This page is only to be displayed to devs
// To automatically create accounts for coaches.

const CreateAccount = () => {
  const [formAlert, setFormAlert] = useState<FormAlert | null>(null)
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [pending, setPending] = useState(false)

  const navigate = useNavigate()

  const onCreateAccount = async (e: React.FormEvent) => {
    setPending(true)
    e.preventDefault()
    try {
      let authResponse = await createAuth({ email, password })
      if (authResponse.data.error) throw new Error(authResponse.data.error)

      if (authResponse.data.refresh_token) {
        // Store the tokens
        const refresh = authResponse.data.refresh_token
        const id_token = authResponse.data.id_token
        sessionManager.storeTokens(refresh, id_token)

        // Create the client to set token headers, create a user
        const API = createJoonAPIClient()
        await API.post("api/users/", { name: firstName, last_name: lastName })

        navigate("/")
      }
    } catch (error) {
      const errorMessage = createErrorFromResponse(error)
      if (errorMessage) setFormAlert({ type: "error", message: errorMessage })
      console.log(error)
    } finally {
      setPending(false)
    }
  }

  return (
    <PageWrapper
      style={{
        background: JoonUIColor.background.xlightGray,
        justifyContent: "center",
        alignItems: "center",
        gap: SPACING.space6,
      }}
    >
      <img
        src="/images/logos/JoonCoach.svg"
        alt="Joon Coach Logo"
        style={{ height: "30px" }}
      />
      <FlexBox
        direction="column"
        gap={SPACING.space6}
        align="center"
        style={{
          width: "min(400px, 95vw)",
          border: `1px solid ${JoonUIColor.border.default}`,
          padding: SPACING.space10,
          borderRadius: SPACING.space4,
          background: JoonUIColor.background.primaryNeutral,
          boxShadow: Shadow.high,
        }}
      >
        <Typography variant="h3">Create Account</Typography>
        {formAlert && (
          <CalloutBox type={formAlert.type}>{formAlert.message}</CalloutBox>
        )}

        <form
          onSubmit={onCreateAccount}
          style={{ display: "flex", width: "100%" }}
        >
          <FlexBox gap={SPACING.space4} direction="column">
            <TextInput
              type="email"
              // label="Email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              icon={faEnvelope}
              fullWidth={true}
            />

            <TextInput
              type="password"
              icon={faLock}
              placeholder="Password"
              // label="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              name="pass"
              fullWidth={true}
            />

            <TextInput
              // label="First Name"
              placeholder="First name"
              name="first_name"
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              fullWidth
            />

            <TextInput
              // label="Last Name"
              placeholder="Last name"
              name="last_name"
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              fullWidth
            />

            <Button
              isLoading={pending}
              text="Create Account"
              fullWidth
              type="submit"
              style={{ marginTop: SPACING.space2 }}
            />
          </FlexBox>
        </form>
      </FlexBox>
    </PageWrapper>
  )
}

export default CreateAccount
